import GitHubIcon from '@mui/icons-material/GitHub';
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AddToDriveIcon from "@mui/icons-material/AddToDrive";
import MailIcon from "@mui/icons-material/Mail";


export const links = [
  {
    title: "Mail",
    link: "mailto: meemrumi59@gmail.com",
    icon: MailIcon,
  },
  {
    title: "Github",
    link: "https://github.com/Khurshida-Meem",
    icon: GitHubIcon,
  },
  {
    title: "LinkedIn",
    link: "https://www.linkedin.com/in/khurshida-meem-383488154/",
    icon: LinkedInIcon,
  },
  {
    title: "Resume Drive Link",
    link: "",
    icon: AddToDriveIcon,
  },
];

// {
//     title: "Resume Drive Link",
//     link: "https://drive.google.com/file/d/1HdjClpAYvEZv7pCs-QECjcjCvZX9y1sW/view?usp=sharing",
//     icon: AddToDriveIcon,
//   },